import { Label } from 'components/ui/label';
import { ListBoxInput } from 'components/Inputs/ListBoxInput';
import { Input } from 'components/ui/input';
import { AnimationEasing } from 'eazychart-core';
import { useChartConfig } from 'hooks/useChartConfig';

const easings: { [key in AnimationEasing]: string } = {
  easeLinear: 'Linéaire',
  easeQuad: 'Quadratique',
  easeQuadIn: 'Quadratique (entrée)',
  easeQuadOut: 'Quadratique (sortie)',
  easeQuadInOut: 'Quadratique (entrée/sortie)',
  easeCubic: 'Cubique',
  easeCubicIn: 'Cubique (entrée)',
  easeCubicOut: 'Cubique (sortie)',
  easeCubicInOut: 'Cubique (entrée/sortie)',
  easePoly: 'Polynomiale',
  easePolyIn: 'Polynomiale (entrée)',
  easePolyOut: 'Polynomiale (sortie)',
  easePolyInOut: 'Polynomiale (entrée/sortie)',
  easeSin: 'Sinusoïdale',
  easeSinIn: 'Sinusoïdale (entrée)',
  easeSinOut: 'Sinusoïdale (sortie)',
  easeSinInOut: 'Sinusoïdale (entrée/sortie)',
  easeExp: 'Exponentielle',
  easeExpIn: 'Exponentielle (entrée)',
  easeExpOut: 'Exponentielle (sortie)',
  easeExpInOut: 'Exponentielle (entrée/sortie)',
  easeCircle: 'Circulaire',
  easeCircleIn: 'Circulaire (entrée)',
  easeCircleOut: 'Circulaire (sortie)',
  easeCircleInOut: 'Circulaire (entrée/sortie)',
  easeBounce: 'Rebond',
  easeBounceIn: 'Rebond (entrée)',
  easeBounceOut: 'Rebond (sortie)',
  easeBounceInOut: 'Rebond (entrée/sortie)',
  easeBack: 'Retour',
  easeBackIn: 'Retour (entrée)',
  easeBackOut: 'Retour (sortie)',
  easeBackInOut: 'Retour (entrée/sortie)',
  easeElastic: 'Élastique',
  easeElasticIn: 'Élastique (entrée)',
  easeElasticOut: 'Élastique (sortie)',
  easeElasticInOut: 'Élastique (entrée/sortie)',
};

export const AnimationForm = () => {
  const {
    chart: {
      props: { animationOptions },
    },
    updateChartProps,
  } = useChartConfig();

  const easingOptions = Object.entries(easings).map(([value, label]) => ({
    value,
    label,
  })) as Array<{ value: AnimationEasing; label: string }>;

  return (
    <form>
      <div className="flex flex-col gap-4">
        <div>
          <ListBoxInput<AnimationEasing>
            defaultValue={animationOptions.easing}
            options={easingOptions}
            onChange={(easing: AnimationEasing) => {
              const newOptions = {
                ...animationOptions,
                easing,
              };
              updateChartProps({
                animationOptions: newOptions,
              });
            }}
          />
        </div>
        <div>
          <Label htmlFor="duration">
            Durée <small>(en millisecondes)</small>
          </Label>
          <Input
            id="duration"
            value={animationOptions.duration}
            onChange={(e) => {
              const newDuration = parseInt(e.target.value);
              const newOptions = {
                ...animationOptions,
                duration: !isNaN(newDuration) ? newDuration : 0,
              };
              updateChartProps({
                animationOptions: newOptions,
              });
            }}
          />
        </div>
        <div>
          <Label htmlFor="delay">
            Délai <small>(en millisecondes)</small>
          </Label>
          <Input
            id="delay"
            value={animationOptions.delay}
            onChange={(e) => {
              const newDelay = parseInt(e.target.value);
              const newOptions = {
                ...animationOptions,
                delay: !isNaN(newDelay) ? newDelay : 0,
              };
              updateChartProps({
                animationOptions: newOptions,
              });
            }}
          />
        </div>
      </div>
    </form>
  );
};
